import { Routes } from '@angular/router';
import { ThemeResolver } from './core/resolvers/theme.resolver';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthResolver } from './core/resolvers/user.resolver';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    resolve: {
      theme: ThemeResolver,
    },
  },
  {
    path: '',
    loadChildren: () => import('./modules/modules.module').then(m => m.ModulesModule),
    canActivate: [AuthGuard],
    resolve: {
      theme: ThemeResolver,
      user: AuthResolver,
    },
  },
];
